module.exports = "1. 这是说明信息\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/specTracker/specTracker-21.txt
// module id = MIhh
// module chunks = 2